import { ApolloClient, DefaultOptions, InMemoryCache, HttpLink } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import { tenantSettings } from "utils/authentication/tenantSettings";

export const AttendanceFormApolloConnection = ({ children }): React.ReactElement => {
  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: "no-cache",
    },
    query: {
      fetchPolicy: "no-cache",
    },
  };

  const client = new ApolloClient({
    link: new HttpLink({ uri: tenantSettings.customConfig.api.baseUrl }),
    cache: new InMemoryCache({}),
    defaultOptions: defaultOptions,
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
